const privilegesData = [
  {
    routes: [
      { group: 'Admin', route: 'Gerência de privilégios', permissionId: 1 },
      {
        group: 'Admin',
        route: 'Edição das listas de seleção',
        permissionId: 2,
      },
    ],
  },
  {
    routes: [
      {
        group: 'Apontamentos',
        route: 'Batidas',
        permissionId: 3,
        disabled: true,
      },
      { group: 'Apontamentos', route: 'Aprovação de Batidas', permissionId: 4 },
      {
        group: 'Apontamentos',
        route: 'Pendências de Apontamento',
        permissionId: 5,
      },
      {
        group: 'Apontamentos',
        route: 'Apontamentos Administrativos',
        permissionId: 6,
      },
    ],
  },
  {
    routes: [
      { group: 'Projetos', route: 'Listagem de Projetos', permissionId: 7 },
      { group: 'Projetos', route: 'Edição de Projetos', permissionId: 8 },
      {
        group: 'Projetos',
        route: 'Alocação de Profissionais',
        permissionId: 9,
      },
      { group: 'Projetos', route: 'Adição de Projetos', permissionId: 10 },
      { group: 'Projetos', route: 'Adicionar Vendas', permissionId: 11 },
    ],
  },
  {
    routes: [
      { group: 'Clientes', route: 'Listagem de Clientes', permissionId: 12 },
      { group: 'Clientes', route: 'Adição de Clientes', permissionId: 13 },
      { group: 'Clientes', route: 'Edição de Clientes', permissionId: 14 },
    ],
  },
  {
    routes: [
      {
        group: 'Funcionários',
        route: 'Listagem de Funcionários',
        permissionId: 15,
      },
      {
        group: 'Funcionários',
        route: 'Adição de Funcionários',
        permissionId: 16,
      },
      {
        group: 'Funcionários',
        route: 'Edição de Funcionários',
        permissionId: 17,
      },
    ],
  },
  {
    routes: [
      {
        group: 'Reembolsos',
        route: 'Solicitação de Reembolsos',
        permissionId: 18,
      },
      {
        group: 'Reembolsos',
        route: 'Histórico de Reembolsos',
        permissionId: 19,
      },
      { group: 'Reembolsos', route: 'Edição de Reembolsos', permissionId: 20 },
      {
        group: 'Reembolsos',
        route: 'Aprovação de Reembolsos',
        permissionId: 21,
      },
    ],
  },
  {
    routes: [
      { group: 'PDI - Admin', route: 'Solicitações', permissionId: 29 },
      { group: 'PDI - Admin', route: 'Resultados da Equipe', permissionId: 22 },
      { group: 'PDI - Admin', route: 'Avaliação de Equipe', permissionId: 23 },
      { group: 'PDI - Admin', route: 'Edição de Formulário', permissionId: 24 },
    ],
  },
  {
    routes: [
      {
        group: 'PDI',
        route: 'Home',
        permissionId: 25,
        info:
          'Habilitar apenas se a função selecionada corresponder a um cargo de coordenador do PDI',
      },
      { group: 'PDI', route: 'Tutorial', permissionId: 26 },
      { group: 'PDI', route: 'Avaliação', permissionId: 27 },
      { group: 'PDI', route: 'Resumo', permissionId: 28 },
    ],
  },
];

export default privilegesData;
